module.exports = __webpack_public_path__ + "img/ts03.cb93d199.png";